import type { PostgrestError } from "@supabase/supabase-js";
import type { MappedError } from "./types";

const isPostgrestError = (err: unknown): err is PostgrestError =>
  typeof err === "object" &&
  err !== null &&
  "code" in err &&
  "message" in err;

const extractConstraint = (err: PostgrestError): string | null => {
  if (err.details) {
    const match = err.details.match(/constraint "([^"]+)"/);
    if (match) return match[1];
  }
  const msgMatch = err.message?.match(/constraint "([^"]+)"/);
  return msgMatch ? msgMatch[1] : null;
};

const extractTable = (err: PostgrestError): string | null => {
  if (err.details) {
    const match = err.details.match(/on table "([^"]+)"/);
    if (match) return match[1];
  }
  return null;
};

export function mapPostgresError(raw: unknown): MappedError {
  if (isPostgrestError(raw)) {
    return {
      code: raw.code ?? null,
      constraint: extractConstraint(raw),
      table: extractTable(raw),
      message: raw.message ?? "",
      raw,
    };
  }

  if (raw instanceof Error) {
    return {
      code: null,
      constraint: null,
      table: null,
      message: raw.message,
      raw,
    };
  }

  if (typeof raw === "string") {
    return {
      code: null,
      constraint: null,
      table: null,
      message: raw,
      raw,
    };
  }

  return {
    code: null,
    constraint: null,
    table: null,
    message: "Unknown error",
    raw,
  };
}
